if (!customElements.get('silberhaze-navigation')) {
  customElements.define('silberhaze-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panels = [...this.querySelectorAll('.sh-nav__details')];
      this.panels.forEach((panel) => {
        panel.addEventListener('toggle', () => {
          panel.querySelector('summary').setAttribute('aria-expanded', String(panel.open));
          if (panel.open) {
            this.panels.forEach((other) => {
              if (other !== panel) other.open = false;
            });
            this.updatePosition();
          }
          const header = this.closest('.header-wrapper');
          if (header) header.preventHide = this.panels.some((item) => item.open);
        }, options);
      });
      const closeOnOutside = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      document.addEventListener('pointerdown', closeOnOutside, options);
      document.addEventListener('click', closeOnOutside, options);
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget) {
          if (!this.contains(event.relatedTarget)) this.close();
        } else {
          requestAnimationFrame(() => {
            if (!this.contains(document.activeElement)) this.close();
          });
        }
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const open = event.target.closest('.sh-nav__details[open]');
        if (!open) return;
        event.preventDefault();
        this.close();
        open.querySelector('summary').focus();
      }, options);
      window.addEventListener('resize', () => {
        if (window.innerWidth < 990) this.close();
        else this.updatePosition();
      }, options);
      window.addEventListener('scroll', () => {
        if (this.panels.some((panel) => panel.open)) this.updatePosition();
      }, { ...options, passive: true });
    }
    updatePosition() {
      const header = this.closest('.header-wrapper');
      if (header) this.style.setProperty('--sh-header-bottom', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    }
    close() {
      this.panels.forEach((panel) => {
        panel.open = false;
        panel.querySelector('summary').setAttribute('aria-expanded', 'false');
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
